"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTransitionableDisabled = void 0;
var _Transitionable = require("./Transitionable.hook");
var useTransitionableDisabled = exports.useTransitionableDisabled = function useTransitionableDisabled(userId, transitionable, roleIds, authorizingGroupIds) {
  var allowOwnerInPendingToSend = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var _a, _b, _c, _d;
  var sendable = (0, _Transitionable.useTransitionableSendable)(userId, transitionable, roleIds, allowOwnerInPendingToSend);
  if (!transitionable) return false;
  var stageId = (_b = (_a = transitionable.transition) === null || _a === void 0 ? void 0 : _a.stage_id) !== null && _b !== void 0 ? _b : 'PAID';
  var owners = (_d = (_c = transitionable.transition) === null || _c === void 0 ? void 0 : _c.owners) !== null && _d !== void 0 ? _d : [];
  var groups = authorizingGroupIds !== null && authorizingGroupIds !== void 0 ? authorizingGroupIds : [];
  switch (stageId) {
    case 'PENDING_TO_SEND':
      return !sendable;
    case 'PENDING_TO_AUTHORIZE':
    case 'PENDING_TO_DEFINE':
    case 'VALIDATION':
    case 'PENDING_ACCOUNTING':
    case 'PENDING_TO_PAY':
    case 'RUNNING':
      var notByUser = owners.find(function (el) {
        return el.individual === userId;
      }) === undefined;
      var notByRole = owners.find(function (el) {
        return el.actor && roleIds.indexOf(el.actor) >= 0;
      }) === undefined;
      var notByGroup = owners.find(function (el) {
        return el.individual && groups.indexOf(el.individual) >= 0;
      }) === undefined;
      return notByUser && notByRole && notByGroup;
    default:
      return true;
  }
};